export enum BillingType {
    Tonnage = 1,
    Toll = 2,
    Concession = 3,
    Free = 4,
    CreditNote = 5,
}

export const BillingTypeName = new Map<number, string>([
    [BillingType.Tonnage, 'Tonnage'],
    [BillingType.Toll, 'Toll'],
    [BillingType.Concession, 'Concession'],  
    [BillingType.Free, 'Free'],  
    [BillingType.CreditNote, 'CreditNote'],  
]);
